// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"693":"a5b3bc0f","773":"428027cc"}[chunkId] + ".chunk.css";
};